export interface IRoute {
  home: "/";
  about: "/about";
  contact: "/contact";
  projects: "/projects";
  snake: "/snake";
}

export const ROUTES: IRoute = {
  home: "/",
  about: "/about",
  contact: "/contact",
  projects: "/projects",
  snake: "/snake",
};
